import React from 'react';
import { Fab, withStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './styles';

const PF2MFinalizeButton = ({
  onClick,
  disabled,
  classes,
  ...props
}) => {
  const { t: translate } = useTranslation();

  return (
    <Fab
      variant="extended"
      color="secondary"
      size="large"
      onClick={onClick}
      disabled={disabled}
      className={classes.button}
      {...props}
    >
      <CheckIcon className={classes.icon} />
      {translate('common:Finalize').toUpperCase()}
    </Fab>
  );
};

PF2MFinalizeButton.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.any,
};

PF2MFinalizeButton.defaultProps = {
  classes: {},
  disabled: false,
  onClick: () => {},
};

export default withStyles(styles)(PF2MFinalizeButton);
